module.exports = "img/flags/BY.d4b7a07.png";